import axios from "axios";
import { Auth_URL, Lead_Service_URL } from "../Url";

export const getDashboardDetailsActions = {
  GET_DASHBOARD_DETAILS_SUCCESS: "GET_DASHBOARD_DETAILS_SUCCESS",
  GET_DASHBOARD_DETAILS_ERROR: "GET_DASHBOARD_DETAILS_ERROR",
};

export function getDashboardDetailsDetails(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/get/getPartnerLandingPageDetailsByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getDashboardDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getDashboardDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getDashboardDetailsError(err));

          return err.response;
        }
      });
}

export function getDashboardDetailsError(error) {
  return {
    type: getDashboardDetailsActions.GET_DASHBOARD_DETAILS_ERROR,
    payload: error,
  };
}

export function getDashboardDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getDashboardDetailsActions.GET_DASHBOARD_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function getAWSDashboard(props) {
  const { access_token, leadId } = props;
  let values = {};
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/embedUrl`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          return err.response;
        }
      });
}
